import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Button, Input, Spin } from 'antd';
import axios from "axios";
import { USER_SERVER, SOCKET_URL } from '../../../config'
import './Chat.css';
import { PhoneTwoTone, ApiTwoTone, SendOutlined } from '@ant-design/icons';

const { TextArea } = Input;

function Call() {
    const [phoneNumber, setPhoneNumber] = useState('');

    ////////////////////////////////////////// HTTP //////////////////////////////////////////

    function onChangePhoneNumber(e) {
        setPhoneNumber(e.target.value);
    }

    async function onClickCallConnect() {
        console.log('onClickCallConnect', phoneNumber);

        const res = await axios.post(`${USER_SERVER}/call_to_number`, { number: phoneNumber });
        console.log('call_to_number--------->', res);
        if (res.data?.success) {
            alert('OK');
        } else {
            alert('ERROR');
        }

    }

    /////////////////////////////////////// Display ///////////////////////////////////////

    return (
        <div style={{ marginLeft: '10px', marginRight: '10px' }}>
            <Row justify="center">
                <Col span={8} style={{ textAlign: 'center' }}>
                    <h1>호출 받을 전화번호: </h1>
                </Col>
                <Col span={8} style={{ textAlign: 'center' }}>
                    <Input placeholder="01036171234"  value={phoneNumber} onChange={onChangePhoneNumber}/>
                </Col>
            </Row>
            <Row align="middle" justify="space-between" style={{ marginTop: '10px' }}>
                {/* ------------- call button ------------- */}
                <Col span={20} style={{ textAlign: 'center' }}>

                    <PhoneTwoTone
                        onClick={onClickCallConnect}
                        style={{


                            fontSize: '32px',
                            borderRadius: '50%',
                            border: '2px solid lightblue',
                            padding: '8px'
                        }}
                    />
                </Col>
            </Row>
        </div>
    )
}

export default Call
